const translation = {
  landingpage_title: "Kiểm tra hóa đơn chưa thanh toán",
  landingpage_note: "Nhập mã để kiểm tra các hóa đơn cần thanh toán",
  customer_id: "Mã khách hàng",
  tax_number: "Mã số thuế",
  search_invoices_button: "TÌM HÓA ĐƠN",
  warning_modal_title: "Thông báo",
  warning_modal_max_invoices:
    "Vui lòng chọn tối đa {{number}} hóa đơn/lần thanh toán.",
  warning_modal_payment_expire:
    "Quá hạn thanh toán lại. Vui lòng tìm kiếm và chọn lại hóa đơn.",
  warning_modal_empty_fields: "Vui lòng không bỏ trống các mục cần điền.",
  warning_modal_invalid_customer_id_format:
    "Vui lòng nhập 5-15 kí tự số và không bao gồm khoảng trắng.",
  warning_modal_invalid_tax_number_format:
    'Chỉ hỗ trợ nhập 10-15 kí tự số, 1 kí tự gạch nối "-" và không bao gồm khoảng trắng.',
  list_of_unpaid_invoices: "Danh sách hóa đơn chưa thanh toán",
  vat_invoice_serial: "Ký hiệu",
  invoice_date: "Ngày phát hành",
  total_amount: "Tổng tiền",
  remaining_amount: "Số tiền phải trả",
  select_all: "Chọn tất cả",
  selecting: "Đang chọn <0>{{number1}}/{{number2}}</0>",
  invoice: "Hóa đơn",
  amount: "Số tiền (₫)",
  total: "Tổng",
  no_invoice_message: "Không còn hóa đơn chưa thanh toán.",
  no_invoice_or_invalid_message:
    "Không còn hóa đơn chưa thanh toán hoặc nhập thông tin tìm kiếm chưa chính xác. Nhập lại thông tin?",
  re_type: "Nhập lại",
  return: "Trở về",
  pay_button: "THANH TOÁN",
  success_title: "THANH TOÁN THÀNH CÔNG",
  success_message:
    "Vui lòng theo dõi trạng thái gạch nợ với STADA để đảm bảo các hóa đơn đã được gạch nợ thành công.",
  redirect_message:
    "Hệ thống sẽ tự động chuyển về trang truy vấn hóa đơn sau {{countdown}} giây.",
  failure_title: "THANH TOÁN THẤT BẠI",
  payment_expire_message:
    "Đơn hàng đã bị hủy hoặc hết hạn thanh toán. Vui lòng đợi giây lát để trở về danh sách và chọn lại hóa đơn.",
  payment_failure_message: "Vui lòng thực hiện thanh toán lại.",
  failure_try_again_button: "THANH TOÁN LẠI",
  failure_redirect_homepage_button: "TRỞ VỀ MÀN HÌNH CHÍNH",
  redirect_modal_message:
    "Hệ thống đang chuyển hướng bạn đến cổng thanh toán...",
  close_button: "Đóng",
  notification: "Thông báo",
  network_error: "Mất kết nối đến hệ thống.",
};
export { translation };
